<script lang="ts">
    import '../app.css'
    import { onDestroy } from 'svelte'
    import { invalidateAll, onNavigate } from '$app/navigation'
    import favicon from '$lib/assets/favicon.ico'
    import { getTextDirection } from '$lib/paraglide/runtime.js'
    import { invalidateRouteAuthorizationOnAuthenticationChange } from '$lib/routing/auth-routing.js'
    import { setAppContext } from '$lib/context/app-context.svelte.js'
    import { setAppServices } from '$lib/services/app-services.js'
    import { getAppRuntime } from '$lib/runtime/app-runtime.js'
    import AuthRouteTransitions from '$lib/ui/auth/AuthRouteTransitions.svelte'
    import PostLoginNavigationFeedback from '$lib/ui/auth/PostLoginNavigationFeedback.svelte'
    import AccountDeletionManualRemovalNotice from '$lib/ui/profile/delete-account/AccountDeletionManualRemovalNotice.svelte'
    import {
        MyAccountReturnState,
        setMyAccountReturnState
    } from '$lib/ui/shell/my-account-return-state.svelte.js'
    import { getShellDestinationId } from '$lib/ui/shell/shell-destination.js'

    let { children } = $props()

    const { appContext, appServices } = getAppRuntime()
    const { locale } = appServices

    setAppContext(appContext)
    setAppServices(appServices)
    const myAccountReturnState = setMyAccountReturnState(new MyAccountReturnState())

    const unsubscribe = appServices.auth.subscribe(({ current, previous }) => {
        if (current !== previous) {
            myAccountReturnState.clear()
        }
        invalidateRouteAuthorizationOnAuthenticationChange(previous, current, invalidateAll)
    })

    onNavigate(({ complete, from, to }) => {
        if (
            getShellDestinationId(from?.url.pathname ?? '') === 'my-account' &&
            getShellDestinationId(to?.url.pathname ?? '') !== 'my-account'
        ) {
            void complete.then(() => myAccountReturnState.clear()).catch(() => undefined)
        }
    })

    const textDirection = $derived(getTextDirection(locale.current))

    // Author note: document language and direction are external DOM state owned by the app root.
    // A derived value cannot apply those attributes, element attachments do not target the root
    // document element, and event handlers do not cover locale changes from every app surface.
    $effect(() => {
        const currentLocale = locale.current

        document.documentElement.lang = currentLocale
        document.documentElement.dir = textDirection
    })

    onDestroy(unsubscribe)
</script>

<svelte:head>
    <link rel="icon" href={favicon} />
</svelte:head>

<AuthRouteTransitions />
<PostLoginNavigationFeedback />
{#key locale.accountRevision}
    {@render children()}
    <AccountDeletionManualRemovalNotice />
{/key}
